/**
 * @fileoverview One evaluative item (skill/content) the student self-scores 1–5
 * using the shared "hands" picker (same evaluation UI as the other assessment
 * drawers). Shows the rubric for the selected score. Color-coded left border.
 */

import { Box, Paper, Stack, Text } from '@mantine/core'
import type { ScoreItem } from '../types'
import { ScorePicker } from './ScorePicker'

interface AssessmentScoreItemProps {
  item: ScoreItem
  value: number
  onChange: (score: number) => void
  /** 'blue' for skills, 'green' for standards (matches the other drawers). */
  color?: 'blue' | 'green'
}

export function AssessmentScoreItem({ item, value, onChange, color = 'green' }: AssessmentScoreItemProps) {
  const rubric = value > 0 ? item.rubrics?.[String(value)] : undefined

  return (
    <Paper withBorder radius="md" p="md" style={{ borderLeft: `4px solid ${item.color}` }}>
      <Stack spacing="sm">
        <Stack spacing={2}>
          <Text size="xs" color="dimmed">{item.lv1Name}</Text>
          <Text size="sm" weight={500}>{item.name}</Text>
        </Stack>

        <ScorePicker value={value} onChange={onChange} color={color} rubrics={item.rubrics} />

        {rubric && (
          <Box>
            <Text size="sm" color="dimmed">{rubric}</Text>
          </Box>
        )}
      </Stack>
    </Paper>
  )
}
